import { useEffect, useState } from 'react';
import { useFirebase } from '../contexts/FirebaseContext';
import { doc, getDoc } from 'firebase/firestore';

const FirebaseTest = () => {
  const { db } = useFirebase();
  const [status, setStatus] = useState('Connecting to Firebase...');
  const [error, setError] = useState('');

  useEffect(() => {
    const testConnection = async () => {
      try {
        // Try to read a non-existent document to test the connection
        const docRef = doc(db, 'test', 'test');
        await getDoc(docRef);
        setStatus('✅ Successfully connected to Firebase!');
      } catch (err) {
        if (err instanceof Error) {
          if (err.message.includes('permission-denied')) {
            setStatus('✅ Successfully connected to Firebase! (but got permission denied, which is expected)');
          } else {
            setError(`Error: ${err.message}`);
            setStatus('❌ Failed to connect to Firebase');
          }
        } else {
          setError('An unknown error occurred');
          setStatus('❌ Failed to connect to Firebase');
        }
      }
    };

    testConnection();
  }, [db]);

  return (
    <div style={{ 
      padding: '20px', 
      margin: '20px', 
      border: '1px solid #ccc',
      borderRadius: '8px',
      maxWidth: '600px',
      backgroundColor: '#f9f9f9'
    }}>
      <h2>Firebase Connection Test</h2>
      <p>{status}</p>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      
      <div style={{ marginTop: '20px', fontSize: '0.9em', color: '#666' }}>
        <p><strong>Note:</strong> This is a test component. You can remove it after verifying your Firebase connection.</p>
      </div>
    </div>
  );
};

export default FirebaseTest;
